import React from "react";
import { Route, Routes } from "react-router-dom";
import InstructionVideoList from "./list/InstructionVideoList";
import AddInstructionVideo from "./add/AddInstructionVideo";

const InstructionVideo = () => {
  return (
    <Routes>
      <Route path="" element={<InstructionVideoList />} />
      <Route path="/add" element={<AddInstructionVideo />} />
      <Route path="/edit/:id" element={<AddInstructionVideo />} />
    </Routes>
  );
};

export default InstructionVideo;
